import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVocabulary, searchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Link } from 'react-router-dom';
import SmallNews from '../Views/NewsContainerView/SmallNews';

const LOCATION_VOCAB =
  'hornundhorn.contenttypes.vocabularies.metadata_location';
const defaultNews = [];

const DashboardNews = () => {
  const dispatch = useDispatch();
  const newsItems =
    useSelector((state) => state?.search?.subrequests?.dashboardNews?.items) ||
    defaultNews;
  const locations = useSelector(
    (state) => state.vocabularies?.[LOCATION_VOCAB]?.items,
  );

  const locationMap = useMemo(() => {
    const map = {};
    if (locations) {
      locations.forEach((loc) => {
        map[loc.value] = loc.label;
      });
    }
    return map;
  }, [locations]);

  useEffect(() => {
    dispatch(getVocabulary({ vocabNameOrURL: LOCATION_VOCAB, size: 1000 }));
    dispatch(
      searchContent(
        '/neuigkeiten',
        {
          'path.depth': 1,
          portal_type: ['News Item'],
          exclude_from_nav: false,
          metadata_fields: [
            'created',
            'visited_users',
            'location',
            'image_scales',
          ],
          b_size: 5,
          sort_on: 'modified',
          sort_order: 'reverse',
          review_state: 'published',
        },
        'dashboardNews',
      ),
    );
  }, [dispatch]);

  return (
    <>
      <div className={'dashboard-news'}>
        {newsItems.map((newsItem, idx) => (
          <SmallNews
            title={newsItem.title}
            image={
              newsItem.image_scales?.image
                ? newsItem.image_scales.image[0]
                : null
            }
            id={flattenToAppURL(newsItem['@id'])}
            visited_users={newsItem.visited_users ?? []}
            description={newsItem.description}
            created={newsItem.created}
            location={(newsItem.location ?? []).map((token) => ({
              title: locationMap[token] ?? token,
              token,
            }))}
            review_state={newsItem.review_state}
            onMouseEnter={() => {}}
            readed={true}
            key={idx}
          />
        ))}

        {newsItems.length > 0 && (
          <Link to={'/neuigkeiten'} className={'btn huh primary all-news'}>
            Alle Neuigkeiten
          </Link>
        )}
      </div>
    </>
  );
};

export default DashboardNews;
